import request from '@/utils/request'

export function fetchList(params) {
  return request({
    url: '/ctr-admin/shop/list',
    method: 'get',
    params: params
  })
}

export function fetchAllShopList() {
  return request({
    url: '/ctr-admin/shop/listAll',
    method: 'get'
  })
}

export function create(data) {
  return request({
    url: '/ctr-admin/shop/create',
    method: 'post',
    data: data
  })
}

export function update(id, data) {
  return request({
    url: '/ctr-admin/shop/update/' + id,
    method: 'post',
    data: data
  })
}

export function getShopCurrentInfo() {
  return request({
    url:'/ctr-admin/shop/currentInfo',
    method:'get'
  });
}


export function updateStatus(id, params) {
  return request({
    url: '/ctr-admin/shop/updateStatus/' + id,
    method: 'post',
    params: params
  })
}

export function del(id) {
  return request({
    url:'/ctr-admin/shop/delete/' + id,
    method:'post'
  })
}

export function allocShop(data) {
  return request({
    url: '/ctr-admin/shop/allocManager',
    method: 'post',
    data: data
  })
}

export function getShopByAdmin(adminid) {
  return request({
    url: '/ctr-admin/shop/getShopByAdmin/' + adminid,
    method: 'post'
  })
}


// WEBPACK FOOTER //
// ./src/api/shop.js